import { useTimesheet } from "../context";
import React from "react";

const HeaderTitle = ({ className, children, ...props }) => {
  const {
    data: { day, date, areLogsReviewed },
  } = useTimesheet();

  if (typeof children === "function") {
    return children({ date, day, areLogsReviewed });
  }

  return (
    <h2 className={className} {...props}>
      {children || day}
    </h2>
  );
};

const HeaderDescription = ({ className, children, ...props }) => {
  const {
    data: { formattedDate },
  } = useTimesheet();

  return (
    <p className={className} {...props}>
      {typeof children === "function" 
        ? children({ day })
        : children || formattedDate}
    </p>
  );
};

export { HeaderTitle, HeaderDescription };
